// extracted by mini-css-extract-plugin
export var contactForm = "contact-form-module--contact-form--nQM7L";
export var contactGetUpdates = "contact-form-module--contact-get-updates--aLliY";
export var successMessage = "contact-form-module--success-message--9lPoS";